import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { useForgotPasswordMutation } from "@/services";
import { toast } from "sonner";
import { getRequiredFields, removeEmptyFields } from "@/lib/utils";
import { schema } from "./validations";
import { EMAIL_ID } from "./consts";
import { setForgotPwdEmail } from "@/redux/slices";
import { useDispatch } from "react-redux";
import { useState } from "react";

const useForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showEmailMsg, setShowEmailMsg] = useState<boolean>(false);
  const form = useForm<any>({
    defaultValues: {
      [EMAIL_ID]: "",
    },
    resolver: zodResolver(schema),
  });

  // Dynamically determine required fields
  const requiredFields = getRequiredFields(schema);

  const { mutate: forgotPasswordInfo, isPending: isForgotPasswordPending } =
    useForgotPasswordMutation({
      onError: (error?: any) => {
        toast.error(
          typeof error?.response?.data?.message === "string"
            ? error?.response?.data?.message
            : "Something went wrong",
          {
            className: "!bg-red-500 !text-white",
          }
        );
        return error?.response?.data?.message;
      },
      onSuccess: () => {
        setShowEmailMsg(true);
        dispatch(setForgotPwdEmail(form.watch(EMAIL_ID)));
      },
    });

  const onSubmit = (data: any) => {
    const _data = removeEmptyFields(data);

    forgotPasswordInfo({ data: _data });
  };

  const onEmailSentOkClick = () => {
    setShowEmailMsg(false);
    navigate("/login");
  };

  return {
    navigate,
    form,
    requiredFields,
    onSubmit,
    isForgotPasswordPending,
    onEmailSentOkClick,
    showEmailMsg,
  };
};

export default useForgotPassword;
